// extracted by mini-css-extract-plugin
module.exports = {"signinInfo":"SigninInfo_signinInfo__1DwRU","signedInMessage":"SigninInfo_signedInMessage__3cjME","linkButton":"SigninInfo_linkButton__1xdK2"};